import FullWidthSection from '@/components/full-width-section';
import { FRANCHISE_PROCESS_DATA } from '@/data/franchise/data';
import ProcessCard from './process-card';

export default function ProcessSection() {
  return (
    <FullWidthSection className="desktop:pb-30 bg-gradient-to-b from-[#F3F4FA] to-[#FFFFFF] px-6 pb-15">
      <div className="desktop:web-w desktop:mx-auto">
        <h2 className="typo-28 text-level-2 desktop:typo-50 desktop:pt-30 pt-20 text-center font-black">
          창업절차
        </h2>
        <div className="typo-24 text-level-1 desktop:typo-40 desktop:leading-relaxed desktop:pb-5 pt-7 text-center font-extrabold">
          드라이빙존 창업,
          <span className="text-main-orange"> 어떻게 진행 </span>
          될까?
        </div>
        <div className="desktop:grid-cols-4 desktop:pb-20 grid grid-cols-1 gap-6.5 pt-10 pb-10">
          {FRANCHISE_PROCESS_DATA.map((item) => (
            <ProcessCard key={item.idx} {...item} />
          ))}
        </div>
        <div className="typo-20 text-level-2 desktop:typo-32 inline-block w-full text-center font-semibold">
          <div className="bg-main-yellow desktop:w-[615px] desktop:mx-auto rounded-full py-3">
            언제든지 <span className="font-extrabold">상담신청</span>이
            가능합니다!
          </div>
        </div>
        <p className="typo-18 text-level-2 desktop:typo-24 desktop:leading-relaxed pt-6 text-center leading-relaxed font-semibold">
          입력해주신 내용을 확인 후 연락처 및 메일로 <br />
          빠른 시일내에 답변드리겠습니다.
        </p>
      </div>
    </FullWidthSection>
  );
}
